"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./style.scss");
var mack_component_library_1 = require("mack-component-library");
var PageDataContext_1 = __importDefault(require("~contexts/PageDataContext"));
var CuratedChoices_1 = __importDefault(require("~pages/CuratedChoices"));
var App = function () {
    return (react_1.default.createElement(PageDataContext_1.default, null,
        react_1.default.createElement(mack_component_library_1.MediaQueryContext, null,
            react_1.default.createElement(CuratedChoices_1.default, null))));
};
exports.default = App;
